
<div *ngIf="usuarioAutenticadoP" class="card no-wrap card_toolbar">
   <div class="card-body" id="card-toolbar">
      <div class="accordion accordion-no-border">
         <div class="accordion-item">
            <div [id]="'toolbarCollapse'" class="accordion-collapse collapse">
               <div class="accordion-body">
                  <div class="d-flex flex-wrap flex-column justify-content-center">
                     <div class="opt-hv opt-menu d-flex justify-content-center align-items-center tooltip-ctm"  data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="modalOptions('pesq_pend','modal-lg')"> 
                        <i class="fa-solid fa-magnifying-glass fa-xl text-light" style="z-index: 0;"></i>
                           <span class="tooltiptext-ctm">Pesquisar Pendência</span>
                     </div>        
                     <div class="opt-hv opt-menu d-flex justify-content-center align-items-center tooltip-ctm" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="modalOptions('view_danfe','')">
                        <i class="fa-solid fa-file-invoice fa-xl ms-1 text-light" style="z-index: 0;"></i>
                        <span class="tooltiptext-ctm">Visualizar Danfe a partir de Arquivo XML</span>
                     </div>        
                     <div class="opt-hv opt-menu d-flex justify-content-center align-items-center tooltip-ctm" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="modalOptions('rvl_pend','modal-lg')"> 
                        <i class="fa-solid fa-arrow-rotate-right fa-xl text-light" style="z-index: 0;"></i>
                        <span class="tooltiptext-ctm">Revalidar de Pendências</span>
                     </div>
                     <div class="opt-hv opt-menu d-flex justify-content-center align-items-center tooltip-ctm" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="modalOptions('download_xml','')"> 
                        <i class="fa-solid fa-floppy-disk ms-1 fa-xl text-light" style="z-index: 0;"></i>
                        <span class="tooltiptext-ctm">Baixa XML do Sefaz pela Chave de Acesso</span>
                     </div>
                     <div class="opt-hv opt-menu d-flex justify-content-center align-items-center tooltip-ctm" id="import_ne_btn_toolbar" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="modalOptions('import_ne','')"> 
                        <i class="fa-solid fa-download fa-xl text-light" style="z-index: 0;"></i>
                        <span class="tooltiptext-ctm">Importa Nota de Entrada</span>
                     </div>
                     <div class="opt-hv opt-menu d-flex justify-content-center align-items-center tooltip-ctm" id="integr_tipo_btn_toolbar" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="modalOptions('integr_tipo','')"> 
                        <i class="fa-solid fa-list ms-1 fa-xl text-light" style="z-index: 0;"></i>
                        <span class="tooltiptext-ctm">Integração por Tipo</span>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
      <div class="d-flex justify-content-center">
         <button (click)="rotate()"  id="acordButton" class="opt-hv opt-open button-radius border-0 acc" type="button" data-bs-toggle="collapse" data-bs-target="#toolbarCollapse" aria-expanded="false" aria-controls="toolbarCollapse">
            <i id="showMore_button" class="fa-solid fa-chevron-up fa-lg"></i>
         </button>
      </div>
   </div>
 </div>


 <!-- modalOptions -->
<div class="modal fade" id="modalOptions" tabindex="-1" aria-labelledby="modalOptionsLabel" data-bs-backdrop="static" aria-hidden="true">
   <div [class]="'modal-dialog '+ modalSize">
      <div class="modal-content">
         <div [ngSwitch]="option">
            <div *ngSwitchCase="'pesq_pend'">
               <div class="modal-header">
                  <h1 class="modal-title fs-5" id="modalOptionsLabel">Pesquisar Pendência</h1>
                  <button type="button" id="pesq_pend_close_button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
               </div>
               <div class="modal-body">
                  <fieldset>
                     <div id="pendencias_check" class="btn-group d-flex justify-content-center gap-5 mb-3" role="group" aria-label="Basic radio toggle button group">
                        <div class="d-flex flex-column gap-2">
                           <input [disabled]="chk.numero_nf" type="checkbox" class="btn-check" name="chkPendencia1" id="chkPendencia1" autocomplete="off" [(ngModel)]="chk.numero_nf" (click)="marcarTipoPesqPend('numero_nf'); routePesqPend = 'pendencias-nfe'" >
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia1">
                              <div>Número da NF</div>
                              <div>
                                 <span [hidden]="!chk.numero_nf"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.numero_nf"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
      
                           <input [disabled]="chk.destinatario_nfe" type="checkbox" class="btn-check" name="chkPendencia2" id="chkPendencia2" autocomplete="off" [(ngModel)]="chk.destinatario_nfe" (click)="marcarTipoPesqPend('destinatario_nfe'); routePesqPend = 'pendencias-nfe'">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia2">
                              <div>
                                 CNPJ Destinatário NF-e
                              </div>
                              <div>
                                 <span [hidden]="!chk.destinatario_nfe"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.destinatario_nfe"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>

                           <input [disabled]="chk.numero_cte" type="checkbox" class="btn-check" name="chkPendencia3" id="chkPendencia3" autocomplete="off" [(ngModel)]="chk.numero_cte" (click)="marcarTipoPesqPend('numero_cte'); routePesqPend = 'pendencias-cte'" >
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia3">
                              <div>Número da CT-e</div>
                              <div>
                                 <span [hidden]="!chk.numero_cte"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.numero_cte"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
      
                           <input [disabled]="chk.destinatario_cte" type="checkbox" class="btn-check" name="chkPendencia4" id="chkPendencia4" autocomplete="off" [(ngModel)]="chk.destinatario_cte" (click)="marcarTipoPesqPend('destinatario_cte'); routePesqPend = 'pendencias-cte'">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia4">
                              <div>CNPJ Destinatário CT-e</div>
                              <div>
                                 <span [hidden]="!chk.destinatario_cte"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.destinatario_cte"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
                        </div>
                     
                        <div class="d-flex flex-column gap-2">
                           <input [disabled]="chk.emitente_nfe" type="checkbox" class="btn-check" name="chkPendencia5" id="chkPendencia5" autocomplete="off" [(ngModel)]="chk.emitente_nfe" (click)="marcarTipoPesqPend('emitente_nfe'); routePesqPend = 'pendencias-nfe'">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia5">
                              <div>CNPJ Emitente NF-e</div>
                              <div>
                                 <span [hidden]="!chk.emitente_nfe"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.emitente_nfe"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
         
                           <input [disabled]="chk.transportadora_nfe" type="checkbox" class="btn-check" name="chkPendencia6" id="chkPendencia6" autocomplete="off" [(ngModel)]="chk.transportadora_nfe" (click)="marcarTipoPesqPend('transportadora_nfe'); routePesqPend = 'pendencias-nfe'">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia6">
                              <div>CNPJ Transportadora NF-e</div>
                              <div>
                                 <span [hidden]="!chk.transportadora_nfe"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.transportadora_nfe"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
                           
                           <input [disabled]="chk.emitente_cte" type="checkbox" class="btn-check" name="chkPendencia7" id="chkPendencia7" autocomplete="off" [(ngModel)]="chk.emitente_cte" (click)="marcarTipoPesqPend('emitente_cte'); routePesqPend = 'pendencias-cte'">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia7">
                              <div>CNPJ Emitente CT-e</div>
                              <div>
                                 <span [hidden]="!chk.emitente_cte"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.emitente_cte"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
         
                           <input [disabled]="chk.transportadora_cte" type="checkbox" class="btn-check" name="chkPendencia8" id="chkPendencia8" autocomplete="off" [(ngModel)]="chk.transportadora_cte" (click)="marcarTipoPesqPend('transportadora_cte'); routePesqPend = 'pendencias-cte'">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chkPendencia8">
                              <div>CNPJ Transportadora CT-e</div>
                              <div>
                                 <span [hidden]="!chk.transportadora_cte"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="chk.transportadora_cte"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
                        </div>
                     </div>
                     <input type="text" class="form-control" aria-describedby="button-addon2" placeholder="Digite o titulo da pendência" [(ngModel)]="pesquisarPendencia.search_pendencia">
                  </fieldset>
               </div>
               <div class="modal-footer">
                  <button id="pesqPendecias_toolbar_button" class="btn btn-outline-primary" type="button" id="button-addon2" (click)="pesqPendecias()">Pesquisar</button>
               </div>
            </div>
            <div *ngSwitchCase="'view_danfe'">
               <div class="modal-header">
                  <h1 class="modal-title fs-5" id="modalOptionsLabel">Visualizar Danfe a partir de arquivo xml</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
               </div>
               <div class="modal-body">
                  <label for="formFile_pesq_pend" class="form-label">Arquivo xml</label>
                  <input class="form-control mb-3" type="file" id="formFile_pesq_pend" [(ngModel)]="visualizaDanfe" (change)="capturaArquivo($event)" >
               </div>
               <div class="modal-footer">
                  <button id="visualizarDanfe_button" type="button" class="btn btn-outline-primary button_hover" (click)="visualizarDanfe()">visualizar</button>
               </div>
            </div>
            <div *ngSwitchCase="'rvl_pend'">
               <div class="modal-header">
                  <h1 class="modal-title fs-5" id="modalOptionsLabel">Revalidação de Pendências</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
               </div>
               <div class="modal-body">
                  <div id="pendencias_check_rlvd" class="btn-group d-flex justify-content-center gap-5 mb-3" role="group" aria-label="Basic radio toggle button group">
                     <div class="d-flex flex-column gap-2">
                        <input type="checkbox" class="btn-check" name="chk_revalidaPend" id="chk_revalidaPend1" autocomplete="off" [(ngModel)]="revalidaPendecias.chk.tipo_pendencia_nf" (click)="selecionaTipoRvldPend('chk_revalidaPend1')">
                        <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chk_revalidaPend1">
                           <div>Revalidar todas NF-e's</div>
                           <div>
                              <span [hidden]="!revalidaPendecias.chk.tipo_pendencia_nf"><i class="fa-solid fa-circle-check"></i></span>
                              <span [hidden]="revalidaPendecias.chk.tipo_pendencia_nf"><i class="fa-regular fa-circle"></i></span>
                           </div>
                        </label>

                        <input type="checkbox" class="btn-check" name="chk_revalidaPend" id="chk_revalidaPend2" autocomplete="off" [(ngModel)]="revalidaPendecias.chk.tipo_pendencia_ct" (click)="selecionaTipoRvldPend('chk_revalidaPend2')">
                        <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chk_revalidaPend2">
                        <div>Revalidar todos CT-e's</div>
                           <div>
                              <span [hidden]="!revalidaPendecias.chk.tipo_pendencia_ct"><i class="fa-solid fa-circle-check"></i></span>
                              <span [hidden]="revalidaPendecias.chk.tipo_pendencia_ct"><i class="fa-regular fa-circle"></i></span>
                           </div>
                        </label>
                     </div>
                     <div class="d-flex flex-column gap-2">
                        <input type="checkbox" class="btn-check" name="chk_revalidaPend" id="chk_revalidaPend3" autocomplete="off" [(ngModel)]="revalidaPendecias.chk.tipo_pendencia_tms" (click)="selecionaTipoRvldPend('chk_revalidaPend3')">
                        <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chk_revalidaPend3">
                           <div>Revalidar todas NF-e's TMS</div>
                           <div>
                              <span [hidden]="!revalidaPendecias.chk.tipo_pendencia_tms"><i class="fa-solid fa-circle-check"></i></span>
                              <span [hidden]="revalidaPendecias.chk.tipo_pendencia_tms"><i class="fa-regular fa-circle"></i></span>
                           </div>
                        </label>
      
                        <input type="checkbox" class="btn-check" name="chk_revalidaPend" id="chk_revalidaPend4" autocomplete="off" [(ngModel)]="revalidaPendecias.chk.tipo_pendencia_tipo" (click)="selecionaTipoRvldPend('chk_revalidaPend4')">
                        <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2" for="chk_revalidaPend4">
                           <div>Revalidar todas NF-e's Tipo Integracao</div>
                           <div>
                              <span [hidden]="!revalidaPendecias.chk.tipo_pendencia_tipo"><i class="fa-solid fa-circle-check"></i></span>
                              <span [hidden]="revalidaPendecias.chk.tipo_pendencia_tipo"><i class="fa-regular fa-circle"></i></span>
                           </div>
                        </label>
                     </div>
                  </div>
                  <fieldset>
                     <div class="d-flex gap-2">
                        <div class="col-6">
                           <label for="data_de" class="form-label">De:</label>
                           <input name="data_de" id="revalid_pend_data_de" type="date" class="form-control" [(ngModel)]="revalidaPendecias.data_de">
                        </div>
                        <div class="col-6">
                           <label for="data_ate" class="form-label">Até:</label>
                           <input name="data_ate" id="revalid_pend_data_ate" type="date" class="form-control" [(ngModel)]="revalidaPendecias.data_ate">
                        </div>
                     </div>
                     <div class="text-danger" [hidden]="alertMsg">
                        * Informe as datas para revalidar as Pendências
                     </div>
                     </fieldset>
               </div>
               <div class="modal-footer">
                  <button id="revalidarPendencias_button" type="button" class="btn btn-outline-primary" (click)="revalidarPendencias()">Revalidar</button>
               </div>
            </div>
            <div *ngSwitchCase="'download_xml'">
               <div class="modal-header">
                  <h1 class="modal-title fs-5" id="modalOptionsLabel">Baixa XML</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
               </div>
               <div class="modal-body">
                  <label class="form-label" for="">Chave de Acesso:</label>
                  <input type="text" class="form-control mb-3" [(ngModel)]="baixaXML.AcessKey">

                  <div class="col-12 d-flex justify-content-between gap-2">
                     <div id="chk_dowloadXML" class="col-6">
                        <div class="btn-group" role="group" aria-label="Basic checkbox toggle button group">
                           <input type="checkbox" class="btn-check" id="chk_dowloadXML1" autocomplete="off" [(ngModel)]="baixaXML.chk.tms" (click)="selecionaTipoBaixaXML('chk_dowloadXML1')">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-end-0 rounded-0 rounded-start" for="chk_dowloadXML1">
                              <div>TMS</div>   
                              <div>
                                 <span [hidden]="!baixaXML.chk.tms"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="baixaXML.chk.tms"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
                           
                           <input type="checkbox" class="btn-check" id="chk_dowloadXML2" autocomplete="off" [(ngModel)]="baixaXML.chk.devolucao" (click)="selecionaTipoBaixaXML('chk_dowloadXML2')">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2 border-end-0 rounded-0" for="chk_dowloadXML2">
                              <div>Devoluçâo</div>
                              <div>
                                 <span [hidden]="!baixaXML.chk.devolucao"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="baixaXML.chk.devolucao"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
                           
                           <input type="checkbox" class="btn-check" id="chk_dowloadXML3" autocomplete="off" [(ngModel)]="baixaXML.chk.provisoria" (click)="selecionaTipoBaixaXML('chk_dowloadXML3')">
                           <label class="btn-chk btn-outline-secondary d-flex justify-content-between gap-2  rounded-0 rounded-end" for="chk_dowloadXML3">
                              <div>Provisória</div>
                              <div>
                                 <span [hidden]="!baixaXML.chk.provisoria"><i class="fa-solid fa-circle-check"></i></span>
                                 <span [hidden]="baixaXML.chk.provisoria"><i class="fa-regular fa-circle"></i></span>
                              </div>
                           </label>
                        </div>
                     </div>
                     <div [hidden]="alertMsg" class="text-danger col-5">
                        * Informe uma chave de acesso de NF-e
                     </div>
                  </div>
                  <div class="col-12 text-danger mt-2">
                     * Prazo de download: 30 dias da data de autorizacao de uso
                     ou data de recebimento da NF-e no órgao consultado
                  </div>
               </div>
               <div class="modal-footer">
                  <button id="baixarXML_button" type="button" class="btn btn-outline-primary" (click)="baixarXML()">Baixar</button>
                  <button type="button" class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#file_p_download_xml">Enviar</button>
               </div>
            </div>
            <div *ngSwitchCase="'send_lot'">
               <div class="modal-header">
                  <h1 class="modal-title fs-5" id="modalOptionsLabel">Envio de Lote para Download</h1>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
               </div>
               <div class="modal-body">
                  <div class="col-12 mb-3 d-flex justify-content-center gap-2">
                     <div class="col-6">
                        <label for="formFile_send_lot" class="form-label">Arquivo(Favor enviar Zipado)</label>
                        <input class="form-control" type="file" id="formFile_send_lot" [(ngModel)]="XMLfile">
                     </div>
                     <div class="col-6">
                        <label class="form-label">Tipo de XML</label>
                        <select class="form-control" name="tipo_xml" [(ngModel)]="loteDownload.tipo">
                           <option value="NFE">NFE</option>
                           <option value="CTE">CTE</option>
                        </select>
                     </div>
                  </div>
                  <label class="form-label" for="">Nome do Arquivo a ser Gerado:</label>
                  <input type="text" class="form-control mb-3" [(ngModel)]="loteDownload.nome">
               </div>
               <div class="modal-footer">
                  <button id="enviaLoteDownload_button" type="button" class="btn btn-outline-primary" (click)="enviaLoteDownload()">Enviar</button>
               </div>
            </div>
            <div *ngSwitchCase="'import_ne'">
               <form #formimport_ne="ngForm">
                  <div class="modal-header">
                     <h1 class="modal-title fs-5" id="modalOptionsLabel">Importa Nota Entrada</h1>
                     <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
                     </div>
                  <div class="modal-body">
                     <label for="formFile_import_ne" class="form-label">Arquivo:</label>
                     <input class="form-control mb-3" type="file" id="formFile_import_ne" [(ngModel)]="importFile" (change)="capturaArquivo($event)" required>
                     <div class="col-12 text-danger mt-2">*  O arquivo deve estar compactado em .zip</div>
                  </div>
                  <div class="modal-footer">
                     <button id="importNotaEntrada_button" type="button" class="btn btn-outline-primary" (click)="importNotaEntrada()" [disabled]="!formimport_ne.form.valid">Enviar</button>
                  </div>
               </form>
            </div>

            <!-- <div *ngSwitchCase="'maint_dp-itens'">
               <div class="modal-header">
               <h1 class="modal-title fs-5" id="modalOptionsLabel">Manutenção De-Para de Itens</h1>
               <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
               </div>
               <div class="modal-body">
                  <nav class="col-12 ">
                     <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex pb-1 gap-4 align-items-center text-secondary"> 
                        <i class="fa-solid fa-tag fa-xl"></i>
                        <h2>De &RightArrow; Para Itens</h2>
                        </div>
                        <div class="d-flex pb-1 gap-4 align-items-center text-secondary">
                           <div class="form-outline mb-3 justify-content-end d-flex col-auto">
                              <div class="col-12">
                              <label class="" for="busca_Empresa">Pesquisar:</label>
                              <div class="input-group">
                                 <input class="form-control" id="busca_Empresa" (keyup)="buscaEmpresa(Parametro)"
                                    [(ngModel)]="Parametro" [ngModelOptions]="{standalone: true}" />
                              </div>
                              </div>
                           </div>
                           <div class="mt-1 d-flex justify-content-between gap-2">
                              <button class="btn btn-outline-primary" data-bs-toggle="modal" data-bs-target="#itensModal" (click)="modalUpdate = false"><i class="fa-solid fa-plus"></i> Novo Item</button>
                              <button class="btn btn-outline-primary"><i class="fa fa-solid fa-magnifying-glass"></i> Pesquisar Item</button>
                           </div>
                     </div>
                     </div>
                  </nav>
                  <hr>
                  <div class="modal-body content-scroll">
                     <section class=" gradient-form">
                        <div class="px-2 ">
                        <div class="row d-flex justify-content-center align-items-center ">
                           <div class="col-xl-12">
                              <div class="text-black">
                              <div class="row g-0">
                                 <div class="card-body px-5">
                                    <div class="text-center">
                                    <h4 class="mb-2 pb-1">Lista de Itens</h4>
                                    </div>
                                    <div *ngIf="DeparalistaItensFiltro != undefined && DeparalistaItensFiltro.length > 0; then thenTrue else thenFalse"></div>
                                    <ng-template #thenTrue>
                                    <div class="position-sticky mt-3">
                                       <div class="row g-4">
                                          <div class="w-49" *ngFor="let Item of DeparalistaItensFiltro; let i = index">
                                          <div class="card no-wrap">
                                             <div class="card-body">
                                                <div class="d-flex flex-column mb-3">
                                                <div class="d-flex align-items-center justify-content-between">
                                                      <div class="d-flex flex-wrap  justify-content-start gap-4">
                                                         <div class="d-flex">
                                                            <i *ngIf="Item.utiliza_fat_conver" class="fa-regular fa-circle-check icon-status text-success"></i>
                                                            <i *ngIf="!Item.utiliza_fat_conver" class="fa-regular fa-circle-xmark icon-status text-danger"></i>
                                                            <h5 class="ms-3 mb-2 mt-2"> {{ Item.fornecedor }} </h5>
                                                         </div>
                                                      </div>
                                                      <div class="d-flex align-self-start">
                                                         <div class="dropstart align-text-bottom">
                                                            <button class="btn btn-outline-secondary button-radius" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <i class="fa-solid fa-ellipsis-vertical"></i>
                                                            </button>
                                                            <ul class="dropdown-menu">
                                                            <li><a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#itensModal" (click)="modalUpdateSet(Item.id)"><i class="fa-solid fa-pen"></i>&nbsp;&nbsp;Alterar</a></li>
                                                            <li><a class="dropdown-item" data-bs-toggle="modal"  data-bs-target="#modalAlert" (click)="exclusaoItem(Item.id)"><i class="fa-solid fa-trash"></i>&nbsp;&nbsp;Excluir</a></li>
                                                            </ul>
                                                         </div>
                                                      </div>
                                                   </div>
                                                   <div class="d-flex flex-wrap gap-4">
                                                      <div class="d-flex">
                                                         <h6 class="text-secondary ms-3 mb-2 mt-2">Tipo de Item:</h6>
                                                         <p class="ms-2 mb-2 mt-1"> {{Item.tipo}}</p>
                                                      </div>
                                                      <div class="d-flex">
                                                         <h6 class="text-secondary ms-3 mb-2 mt-2">Item de:</h6>
                                                         <p class="ms-2 mb-2 mt-1"> {{Item.item_de}}</p>
                                                      </div>
                                                      <div class="d-flex">
                                                         <h6 class="text-secondary ms-3 mb-2 mt-2">Item para:</h6>
                                                         <p class="ms-2 mb-2 mt-1"> {{Item.item_para}}</p>
                                                      </div>
                                                   </div>
                                                   <div class="accordion accordion-no-border">
                                                      <div class="accordion-item ">
                                                         <div [id]="'collapseOne'+i" class="accordion-collapse collapse">
                                                            <div class="accordion-body">
                                                               <div class="d-flex flex-wrap justify-content-between pt-4 ps-3 pe-3 card-info">
                                                                     <div class="d-flex flex-column">
                                                                        <h6 class="label-custom text-secondary">Empresa:</h6>
                                                                        <p class="mb-4">{{ Item.empresa }}</p>
                                                                     </div>
                                                                     <div class="d-flex flex-column">
                                                                        <h6 class="label-custom text-secondary">Unidade de Medida:</h6>
                                                                        <p>{{ Item.unid_med }}</p>
                                                                     </div>
                                                                     <div class="d-flex flex-column">
                                                                        <h6 class="label-custom text-secondary">Fator de Conversão:</h6>
                                                                        <p>{{ Item.fat_conver }}</p>
                                                                     </div>
                                                               </div>
                                                            </div>
                                                         </div>
                                                      </div>
                                                   </div>
                                                   <div class="d-flex justify-content-center">
                                                      <button [id]="'acordButton'+i" (click)="moreInformation(i)" class="btn btn-outline-secondary button-radius border-0" type="button" [attr.data-bs-toggle]="'collapse'" [attr.data-bs-target]="'#collapseOne'+i" aria-expanded="false" aria-controls="collapseOne">
                                                         <i class="fa-solid fa-chevron-down"></i>
                                                      </button>
                                                   </div>
                                                </div>
                                             </div>
                                          </div>
                                          </div>
                                       </div>
                                    </div>
                                    </ng-template>
                                    <ng-template #thenFalse>
                                    <app-mensagem [colorMessage]="colorMessage" [titleMessage]="titleMessage"></app-mensagem>
                                    </ng-template>
                                 </div>
                              </div>
                              </div>
                           </div>
                        </div>
                        </div>
                     </section>
                  </div>
               </div>
               <div class="modal-footer">
               <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="limpaForm()">Fechar</button>
               </div>
            </div> -->

            <div *ngSwitchCase="'integr_tipo'">
               <form #formnew="ngForm">
                  <div class="modal-header">
                     <h1 class="modal-title fs-5" id="modalOptionsLabel">Integração por Tipo</h1>
                     <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
                  </div>
                  <div class="modal-body">
                     <label for="formFile_integr_tipo" class="form-label">Arquivo:</label>
                     <input class="form-control mb-3" type="file" id="formFile_integr_tipo" [(ngModel)]="intgTipo" (change)="capturaArquivo($event)" required>
                     <div class="col-12 text-danger mb-1">*  O arquivo deve estar compactado em .zip</div>
   
                     <label class="form-label" for="">Tipo de Integração:</label>
                     <select class="form-control" name="tipo_integracao" [(ngModel)]="integraTipo.tipo" required>
                        <option *ngFor="let Integracao of listaTiposIntegracao2" [value]="Integracao.codigo">{{Integracao.descricao}}</option>
                     </select>
                  </div>
                  <div class="modal-footer">
                     <button id="enviaIntegracaoTipo_button" type="button" class="btn btn-outline-primary" (click)="enviaIntegracaoTipo()" [disabled]="!formnew.form.valid">Enviar</button>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</div>

<!-- Modal Alert -->
<div class="modal fade" id="modalAlert" tabindex="-1" aria-labelledby="modalAlertLabel" aria-hidden="true">
   <div class="modal-dialog h-75 d-flex justify-content-center align-items-center">
     <div class="modal-content">
       <div class="modal-header">
         <h5 class="modal-title" id="modalAlertLabel">{{ModalTitleToolbar}}</h5>
         <button type="button" id="close-modalToolbar" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
       </div>
       <div class="modal-body">
         {{ModalBodyToolbar}}
       </div>
       <div class="modal-footer">
         <div *ngFor="let Button of ModalButtonsToolbar;">
           <button id="first_button_modal_alert" type="button" class="btn {{Button.class}} {{Button.disabled}}" (click)="Button.func" data-bs-dismiss="modal">{{Button.text}}</button>
         </div>
       </div>
     </div>
   </div>
 </div>

 <button data-bs-toggle="modal" data-bs-target="#modalAlert" id="show-modalToolbar" hidden></button>
 
 <!-- File picker Baixa XML -->
<div class="modal fade" id="file_p_download_xml" data-bs-backdrop="static" data-bs-keyboard="true" tabindex="-1" aria-labelledby="file_p_download_xmlLabel" aria-hidden="true">
   <div class="modal-dialog">
     <div class="modal-content">
         <div class="modal-header">
            <h1 class="modal-title fs-5" id="file_p_download_xmlLabel">Enviar Arquivo</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="limpaForm()"></button>
         </div>
         <div class="modal-body">
            <label for="formFile" class="form-label">Arquivo</label>
            <div [hidden]="alertMsg" class="text-danger">*Selecione um arquivo</div>
            <input class="form-control mb-3" type="file" id="formFile" [(ngModel)]="XMLfile">
         </div>
         <div class="modal-footer">
            <button id="enviaDownloadXML_button" type="button" class="btn btn-outline-primary" (click)="enviaDownloadXML()">Enviar</button>
         </div>
     </div>
   </div>
 </div>
 
 <!-- <app-modal [ModalTitle]="ModalTitle" [ModalBody]="ModalBody" [ModalButtons]="ModalButtons"></app-modal> -->


  <!-- Modal Insert Update -->
<!-- <div class="modal fade" id="itensModal" tabindex="-1" aria-labelledby="itensModalLabel" aria-hidden="true" data-bs-backdrop="static">
   <form #formnew="ngForm">
     <div class="modal-dialog">
       <div class="modal-content">
         <div class="modal-header">
           <h5 class="modal-title" id="itensModalLabel">Inclusão Tabela de &RightArrow; Para de itens</h5>
           <button type="button" id="itensModal_close" class="btn-close" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="limpaForm()" aria-label="Close"></button>
         </div>
         <div class="modal-body">
           <div class="container">
             <div class="row">
               <div class="col-md-12">
                 <fieldset class="mb-3">
                   <legend class="mb-3">Informações da Itens</legend>
                   <input hidden name="empresaDePara_id" id="empresaDePara_id" #name="ngModel" class="form-control" [(ngModel)]="DeparaItem.id">
 
                   <div class="mb-3 mt-2 row justify-content-center">
                      <div class="col-5">
                        <input type="checkbox" class="btn-check" name="btn-check-normal" #name="ngModel" id="btn-check-normal" [required]="checkboxRequired" [(ngModel)]="checkBtn.normal" >
                        <label class="btn btn-outline-success br-5 w-100" for="btn-check" (click)="marcarTipo('Normal')">Normal</label>
                      </div>
                      <div class="col-5">
                        <input type="checkbox" class="btn-check" name="btn-check-TMS" #name="ngModel" id="btn-check-TMS" [required]="checkboxRequired" [(ngModel)]="checkBtn.tms">
                        <label class="btn btn-outline-success br-5 w-100" for="btn-check-5" (click)="marcarTipo('TMS')">TMS</label>
                      </div>
                    </div>

                    <label for="fornecedor" class="form-label">Fornecedor:</label>
                    <div class="input-group mb-3">
                      <input name="fornecedor" id="fornecedor" #name="ngModel" placeholder="Digite o Fornecedor" class="form-control" [(ngModel)]="DeparaItem.fornecedor" required>
                      <button class="btn btn-outline-secondary" data-bs-target="#popupModal" data-bs-toggle="modal" (click)="tipoPopup = 'Fornecedores'"><i class="fa fa-search"></i></button>
                    </div>

                   <div class="mb-3">
                     <label for="item_de" class="form-label">Item de:</label>
                     <input name="item_de" id="item_de" #name="ngModel" placeholder="Digite o Item" class="form-control" [(ngModel)]="DeparaItem.item_de" required>
                   </div>

                   <label for="item_para" class="form-label">Item para:</label>
                   <div class="input-group mb-3">
                     <input name="item_para" id="item_para" #name="ngModel" placeholder="Digite o Item" class="form-control" [(ngModel)]="DeparaItem.item_para" required>
                     <button class="btn btn-outline-secondary" data-bs-target="#popupModal" data-bs-toggle="modal" (click)="tipoPopup = 'Itens'"><i class="fa fa-search"></i></button>
                   </div>

                   <label for="unid_med" class="form-label">Unidade de Medida:</label>
                   <div class="input-group mb-3">
                     <input name="unid_med" id="unid_med" #name="ngModel" placeholder="Digite a Unidade de Medida" class="form-control" [(ngModel)]="DeparaItem.unid_med" required>
                     <button class="btn btn-outline-secondary" data-bs-target="#popupModal" data-bs-toggle="modal" (click)="tipoPopup ='Unidade de Medida'"><i class="fa fa-search"></i></button>
                   </div>

                   <div class="mb-3">
                    <label for="fat_conver" class="form-label">Fator de Conversão:</label>
                    <input name="fat_conver" id="fat_conver" #name="ngModel" placeholder="Digite o Fator de Conversão" class="form-control" [(ngModel)]="DeparaItem.fat_conver" required>
                  </div>


                   <div class="mb-3 mt-2 row justify-content-center">
                     <div class="col-5">
                        <input type="checkbox" class="btn-check" name="utiliza_fat_conver" id="utiliza_fat_conver" autocomplete="off" [(ngModel)]="DeparaItem.utiliza_fat_conver">
                        <label for="utiliza_fat_conver" class="btn btn-outline-secondary br-5 w-100">Utiliza Conversão</label>
                     </div>
                     <div class="col-5">
                        <input type="checkbox" class="btn-check" name="utiliza_ctr_estoq" id="utiliza_ctr_estoq" autocomplete="off" [(ngModel)]="DeparaItem.utiliza_ctr_estoq">
                        <label for="utiliza_ctr_estoq" class="btn btn-outline-secondary br-5 w-100">Utiliza Ctr Estoque</label>
                     </div>
                   </div>
                 </fieldset>
             </div>
           </div>
         </div>
        </div>
        <div class="modal-footer">
          <button type="button" (click)="limpaForm()" class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#modalOptions" data-bs-dismiss="modal">Fechar</button>
          <button *ngIf="modalUpdate == false" type="submit" [disabled]="!formnew.form.valid" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="insertItem()">Salvar</button>
          <button *ngIf="modalUpdate == true" type="submit" [disabled]="!formnew.form.valid" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#modalOptions" (click)="updateItem()">Atualizar</button>
        </div>
       </div>
     </div>
   </form>
 </div> -->

 <!-- Popup -->
<!-- <div class="modal fade" id="popupModal" aria-hidden="true" aria-labelledby="popupModalLabel" tabindex="-1">
   <div class="modal-dialog modal-lg">
     <div class="modal-content">
       <div class="modal-header">
         <h1 class="modal-title fs-5" id="popupModalLabel">{{tipoPopup}}</h1>
         <button type="button" data-bs-toggle="modal" data-bs-target="#itensModal" (click)="closePopup()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
       </div>
       <div class="py-2 pe-2 border-bottom">
        <div class="form-outline justify-content-between d-flex col-auto">
          <div class="col-8 ms-3">
            <label class="form-label align-self-center" for="filtro_pesquisa">Filtros:</label>
            <div class="input-group">
              <input type="text" class="form-control w-15" id="filtro_pesquisa" placeholder="Codigo" [(ngModel)]="filtroPopup.cod">
              <input type="text" class="form-control w-50" placeholder="Descrição" aria-label="Descrição" [(ngModel)]="filtroPopup.descricao">
              <button class="btn btn-outline-secondary " type="button" id="button-addon1" (click)="filtroPopups()"><i class="fa-solid fa-magnifying-glass"></i></button>
            </div>
          </div>
             <div class="col-3">
               <label class="form-label align-self-center" for="busca_Itens">Pesquisar:</label>
               <input class="form-control" id="busca_Itens" (keyup)="buscaPopup(ParametroPopups)"
                 [(ngModel)]="ParametroPopups" [ngModelOptions]="{standalone: true}" />
             </div>
         </div>
       </div>
       <div class="modal-body" style="height: 50vh; overflow: auto;">
         <div class="position-sticky mt-3">
           <div class="row g-4">
             <div *ngFor="let ItemPopup of listaPopup">
               <div class="card no-wrap">
                 <div class="card-body" data-bs-toggle="modal" data-bs-target="#itensModal" (click)="selecionaItemPopup(ItemPopup.cod)">
                    <div class="d-flex flex-column mb-3">
                       <div class="d-flex align-items-center justify-content-between">
                       <div class="d-flex flex-wrap justify-content-start gap-4">
                          <div class="d-flex">
                             <i class="fas fa-info-circle icon-status text-secondary"></i>
                             <h5 class="ms-3 mb-2 mt-2">Código - {{ItemPopup.cod}}</h5>
                          </div>
                       </div>
                       </div>
                       <div class="d-flex flex-wrap gap-4">
                          <div class="d-flex">
                             <h6 class="text-secondary ms-3 mb-2 mt-2">Descrição:</h6>
                             <p class="ms-2 mb-2 mt-1"> {{ItemPopup.descricao}}</p>
                          </div>
   
                       </div>
                    </div>
                 </div>
              </div>
             </div>
           </div>
         </div>
       </div>
       <div class="modal-footer">
         <button class="btn btn-secondary" data-bs-toggle="modal" data-bs-target="#itensModal" (click)="closePopup()">Fechar</button>
       </div>
     </div>
   </div>
 </div> -->